module.exports = __webpack_public_path__ + "img/pdf.bc847a91.svg";